var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconM9(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 124 84.4",
    enableBackground: "new 0 0 124 84.4",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M29.1,57.2h3.2c0.9,0,1.6,0.2,2.1,0.7c0.5,0.5,0.8,1.1,0.8,1.9c0,0.8-0.3,1.5-0.8,1.9c-0.5,0.4-1.2,0.7-2.1,0.7h-2v3.2 h-1.2V57.2z M32.2,61.4c0.6,0,1-0.1,1.3-0.3c0.3-0.2,0.5-0.6,0.5-1.2c0-0.6-0.2-1-0.5-1.2c-0.3-0.2-0.8-0.4-1.3-0.4h-1.9v3.1 H32.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4,59.9h1.2v1c0.2-0.4,0.6-0.6,1-0.8c0.4-0.2,0.9-0.3,1.5-0.3v0.9c-0.6,0-1.1,0.1-1.6,0.3c-0.4,0.2-0.7,0.5-0.9,0.9 v3.6h-1.2V59.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3,65.4c-0.5-0.2-0.9-0.6-1.2-1.1c-0.3-0.5-0.4-1-0.4-1.6c0-0.6,0.1-1.2,0.4-1.6c0.3-0.5,0.7-0.8,1.2-1.1 c0.5-0.3,1.1-0.4,1.7-0.4c0.6,0,1.2,0.1,1.7,0.4s0.9,0.6,1.2,1.1c0.3,0.5,0.4,1,0.4,1.6c0,0.6-0.1,1.2-0.4,1.6 c-0.3,0.5-0.7,0.8-1.2,1.1s-1.1,0.4-1.7,0.4C43.4,65.8,42.8,65.7,42.3,65.4z M45.5,64.3c0.4-0.4,0.6-0.9,0.6-1.5 c0-0.6-0.2-1.2-0.6-1.5c-0.4-0.4-0.9-0.6-1.5-0.6s-1.1,0.2-1.5,0.6S42,62.1,42,62.7c0,0.6,0.2,1.1,0.6,1.5 c0.4,0.4,0.9,0.6,1.5,0.6S45.1,64.6,45.5,64.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.6,60.8h-0.9v-0.9h0.9v-1.1c0-0.7,0.2-1.2,0.6-1.5c0.4-0.3,0.9-0.5,1.5-0.5c0.3,0,0.6,0,0.9,0.1v1 c-0.2-0.1-0.5-0.2-0.7-0.2c-0.4,0-0.7,0.1-0.8,0.3c-0.2,0.2-0.3,0.5-0.3,0.8v1.1h1.4v0.9h-1.4v4.8h-1.2V60.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.1,65c-0.6-0.5-0.9-1.3-0.9-2.3c0-0.9,0.3-1.7,0.8-2.2c0.5-0.6,1.3-0.8,2.3-0.8c0.7,0,1.2,0.1,1.7,0.4 c0.5,0.3,0.8,0.6,1,1c0.2,0.4,0.4,1,0.4,1.5v0.6h-5.1c0,0.5,0.3,1,0.7,1.2s1,0.4,1.7,0.4c0.4,0,0.7,0,1.1-0.1 c0.4-0.1,0.7-0.2,1-0.3v1c-0.3,0.1-0.6,0.2-1,0.3s-0.8,0.1-1.2,0.1C54.5,65.8,53.7,65.5,53.1,65z M57.3,62.4c0-0.5-0.2-1-0.5-1.3 s-0.8-0.5-1.4-0.5c-0.6,0-1.1,0.2-1.4,0.5c-0.3,0.3-0.5,0.7-0.5,1.2H57.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.6,65.6c-0.4-0.1-0.8-0.2-1.1-0.4v-1c0.3,0.2,0.7,0.3,1.1,0.4c0.4,0.1,0.8,0.2,1.2,0.2c0.4,0,0.7-0.1,0.9-0.2 c0.2-0.1,0.3-0.3,0.3-0.5c0-0.2,0-0.3-0.1-0.4c-0.1-0.1-0.2-0.2-0.5-0.3c-0.2-0.1-0.5-0.2-1-0.3c-0.5-0.1-0.8-0.3-1.1-0.4 c-0.3-0.1-0.5-0.3-0.6-0.5s-0.2-0.5-0.2-0.8c0-0.6,0.2-1,0.7-1.3c0.4-0.3,1-0.4,1.8-0.4c0.4,0,0.8,0,1.1,0.1 c0.4,0.1,0.7,0.2,0.9,0.3v1c-0.2-0.1-0.5-0.2-0.9-0.3s-0.7-0.1-1-0.1c-0.4,0-0.7,0.1-1,0.2c-0.2,0.1-0.3,0.3-0.3,0.6 c0,0.2,0,0.3,0.1,0.4c0.1,0.1,0.3,0.2,0.5,0.3c0.2,0.1,0.5,0.2,1,0.3c0.7,0.2,1.2,0.4,1.5,0.7c0.3,0.3,0.4,0.6,0.4,1.1 c0,0.5-0.2,0.9-0.6,1.2c-0.4,0.3-1,0.4-1.8,0.4C61.5,65.8,61,65.7,60.6,65.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1,65.6c-0.4-0.1-0.8-0.2-1.1-0.4v-1c0.3,0.2,0.7,0.3,1.1,0.4c0.4,0.1,0.8,0.2,1.2,0.2c0.4,0,0.7-0.1,0.9-0.2 c0.2-0.1,0.3-0.3,0.3-0.5c0-0.2,0-0.3-0.1-0.4c-0.1-0.1-0.2-0.2-0.5-0.3c-0.2-0.1-0.5-0.2-1-0.3c-0.5-0.1-0.8-0.3-1.1-0.4 c-0.3-0.1-0.5-0.3-0.6-0.5s-0.2-0.5-0.2-0.8c0-0.6,0.2-1,0.7-1.3c0.4-0.3,1-0.4,1.8-0.4c0.4,0,0.8,0,1.1,0.1 c0.4,0.1,0.7,0.2,0.9,0.3v1c-0.2-0.1-0.5-0.2-0.9-0.3s-0.7-0.1-1-0.1c-0.4,0-0.7,0.1-1,0.2c-0.2,0.1-0.3,0.3-0.3,0.6 c0,0.2,0,0.3,0.1,0.4c0.1,0.1,0.3,0.2,0.5,0.3c0.2,0.1,0.5,0.2,1,0.3c0.7,0.2,1.2,0.4,1.5,0.7c0.3,0.3,0.4,0.6,0.4,1.1 c0,0.5-0.2,0.9-0.6,1.2c-0.4,0.3-1,0.4-1.8,0.4C67,65.8,66.6,65.7,66.1,65.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.4,58.5c-0.1-0.1-0.2-0.3-0.2-0.5s0.1-0.4,0.2-0.5c0.1-0.1,0.3-0.2,0.5-0.2c0.2,0,0.4,0.1,0.5,0.2s0.2,0.3,0.2,0.5 s-0.1,0.4-0.2,0.5s-0.3,0.2-0.5,0.2C71.7,58.7,71.5,58.7,71.4,58.5z M71.3,59.9h1.2v5.8h-1.2V59.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.5,65.4c-0.5-0.2-0.9-0.6-1.2-1.1c-0.3-0.5-0.4-1-0.4-1.6c0-0.6,0.1-1.2,0.4-1.6c0.3-0.5,0.7-0.8,1.2-1.1 s1.1-0.4,1.7-0.4c0.6,0,1.2,0.1,1.7,0.4c0.5,0.3,0.9,0.6,1.2,1.1c0.3,0.5,0.4,1,0.4,1.6c0,0.6-0.1,1.2-0.4,1.6 c-0.3,0.5-0.7,0.8-1.2,1.1c-0.5,0.2-1.1,0.4-1.7,0.4C76.6,65.8,76,65.7,75.5,65.4z M78.7,64.3c0.4-0.4,0.6-0.9,0.6-1.5 c0-0.6-0.2-1.2-0.6-1.5s-0.9-0.6-1.5-0.6s-1.1,0.2-1.5,0.6c-0.4,0.4-0.6,0.9-0.6,1.5c0,0.6,0.2,1.1,0.6,1.5 c0.4,0.4,0.9,0.6,1.5,0.6S78.3,64.6,78.7,64.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8,59.9H83v0.8c0.3-0.3,0.6-0.6,1-0.8c0.4-0.2,0.8-0.2,1.2-0.2c0.8,0,1.3,0.2,1.7,0.6c0.4,0.4,0.6,1,0.6,1.6v3.7h-1.2 v-3.6c0-0.9-0.4-1.4-1.3-1.4c-0.4,0-0.7,0.1-1.1,0.3c-0.3,0.2-0.6,0.5-0.9,0.8v3.9h-1.2V59.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2,65.3c-0.4-0.4-0.6-0.8-0.6-1.4c0-0.6,0.2-1.1,0.6-1.5c0.4-0.3,1-0.5,1.7-0.5c0.8,0,1.5,0.2,2,0.5V62 c0-0.5-0.1-0.8-0.4-1s-0.7-0.3-1.3-0.3c-0.4,0-0.7,0-1,0.1c-0.3,0.1-0.6,0.2-0.9,0.3v-1c0.2-0.1,0.6-0.2,0.9-0.3 c0.4-0.1,0.8-0.1,1.1-0.1c1,0,1.7,0.2,2.1,0.6s0.7,1,0.7,1.7v3.6H93V65c-0.2,0.3-0.5,0.5-0.9,0.6c-0.3,0.1-0.8,0.2-1.2,0.2 C90.2,65.8,89.6,65.6,89.2,65.3z M92.2,64.6c0.3-0.2,0.5-0.4,0.7-0.6v-0.8c-0.5-0.3-1.1-0.5-1.7-0.5c-0.5,0-0.8,0.1-1,0.3 c-0.2,0.2-0.3,0.5-0.3,0.8c0,0.7,0.5,1.1,1.4,1.1C91.6,64.9,91.9,64.8,92.2,64.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.7,56.7h1.2v8.9h-1.2V56.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9,71.6h1.2V80h-1.2V71.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.7,74.3h1.2v0.8c0.3-0.3,0.6-0.6,1-0.8c0.4-0.2,0.8-0.2,1.2-0.2c0.8,0,1.3,0.2,1.7,0.6s0.6,1,0.6,1.6V80h-1.2v-3.6 c0-0.9-0.4-1.4-1.3-1.4c-0.4,0-0.7,0.1-1.1,0.3s-0.6,0.5-0.9,0.8V80h-1.2V74.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.2,79.8c-0.5-0.3-0.8-0.6-1.1-1.1c-0.3-0.5-0.4-1-0.4-1.6c0-0.6,0.1-1.1,0.4-1.6c0.3-0.5,0.6-0.8,1.1-1.1 c0.5-0.3,1-0.4,1.6-0.4c1,0,1.8,0.3,2.4,0.9v-3.9h1.2V80h-1.2v-0.8c-0.3,0.4-0.7,0.6-1,0.8s-0.8,0.2-1.3,0.2 C51.1,80.2,50.6,80.1,50.2,79.8z M53.3,78.8c0.4-0.3,0.6-0.6,0.8-1.1v-1.3c-0.1-0.4-0.4-0.8-0.8-1.1S52.5,75,52,75 c-0.4,0-0.7,0.1-1.1,0.3c-0.3,0.2-0.6,0.4-0.7,0.7c-0.2,0.3-0.3,0.7-0.3,1.1s0.1,0.8,0.3,1.1c0.2,0.3,0.4,0.6,0.7,0.7 c0.3,0.2,0.7,0.3,1.1,0.3C52.5,79.2,52.9,79.1,53.3,78.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5,79.4c-0.6-0.5-0.9-1.3-0.9-2.3c0-0.9,0.3-1.7,0.8-2.2s1.3-0.8,2.3-0.8c0.7,0,1.2,0.1,1.7,0.4c0.5,0.3,0.8,0.6,1,1 c0.2,0.4,0.4,1,0.4,1.5v0.6h-5.1c0,0.5,0.3,1,0.7,1.2c0.4,0.3,1,0.4,1.7,0.4c0.4,0,0.7,0,1.1-0.1c0.4-0.1,0.7-0.2,1-0.3v1 c-0.3,0.1-0.6,0.2-1,0.3c-0.4,0.1-0.8,0.1-1.2,0.1C59,80.2,58.1,79.9,57.5,79.4z M61.7,76.8c0-0.5-0.2-1-0.5-1.3 c-0.3-0.3-0.8-0.4-1.4-0.4c-0.6,0-1.1,0.2-1.4,0.5c-0.3,0.3-0.5,0.7-0.5,1.2H61.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.2,74.3h1.2v0.8c0.3-0.3,0.6-0.6,0.9-0.8c0.3-0.2,0.7-0.3,1.1-0.3c0.5,0,0.8,0.1,1.1,0.2c0.3,0.2,0.5,0.4,0.6,0.7 c0.3-0.3,0.6-0.5,0.9-0.7s0.7-0.2,1.1-0.2c0.7,0,1.2,0.2,1.5,0.5c0.3,0.4,0.5,0.9,0.5,1.6V80h-1.2v-3.7c0-0.5-0.1-0.8-0.3-1 c-0.2-0.2-0.5-0.3-0.9-0.3c-0.6,0-1.1,0.3-1.5,0.8c0,0.1,0,0.3,0,0.6V80h-1.2v-3.7c0-0.5-0.1-0.8-0.2-1C67.7,75.1,67.4,75,67,75 c-0.6,0-1.2,0.3-1.6,1V80h-1.2V74.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.8,72.9c-0.1-0.1-0.2-0.3-0.2-0.5c0-0.2,0.1-0.4,0.2-0.5c0.1-0.1,0.3-0.2,0.5-0.2c0.2,0,0.4,0.1,0.5,0.2 c0.1,0.1,0.2,0.3,0.2,0.5c0,0.2-0.1,0.4-0.2,0.5c-0.1,0.1-0.3,0.2-0.5,0.2C75.1,73.1,74.9,73.1,74.8,72.9z M74.7,74.3h1.2V80 h-1.2V74.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.4,79.7c-0.3-0.3-0.5-0.8-0.5-1.4v-3.1h-0.9v-0.9H78v-1.7h1.2v1.7h1.4v0.9h-1.4v3c0,0.4,0.1,0.7,0.2,0.8 c0.1,0.2,0.4,0.2,0.8,0.2c0.2,0,0.5-0.1,0.7-0.2v1c-0.3,0.1-0.7,0.2-1.1,0.2C79.2,80.2,78.7,80,78.4,79.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.7,82.3v-0.9c0.2,0.1,0.5,0.1,0.8,0.1c0.3,0,0.5-0.1,0.7-0.2c0.2-0.1,0.3-0.4,0.4-0.7l0.3-0.7l-2.5-5.6h1.2l1.9,4.4 l1.8-4.4h1.2l-2.6,6.4c-0.2,0.6-0.5,1-0.9,1.3c-0.3,0.3-0.8,0.4-1.3,0.4C82.4,82.4,82,82.3,81.7,82.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M55.9,38.5 l3.1-3.1c1.9-1.9,4.5-3,7.2-3h6.2c0.8,0,1.3,0.8,0.9,1.5l0,0c-0.8,1.5-2.4,2.4-4.1,2.4h-2.7v1.9h9.8l5.7-5.7 c1.1-1.1,3-0.8,3.7,0.6l0,0c0.4,0.9,0.3,1.9-0.4,2.6l-6.8,6.9c-1.5,1.6-3.7,2.4-5.9,2.4H62.4"
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 61.9,50.1 63.1,48.3 52.5,38.5 43.4,48.9  "
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 50.2,
    y1: 41.2,
    x2: 58.4,
    y2: 49.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M80.5,13.2 c-2.5-0.3-5-2.2-6-3.1c-0.3-0.2-0.7-0.2-1,0c-1,0.9-3.5,2.8-6,3.1c-0.4,0.1-0.7,0.4-0.7,0.8c0.3,7.7,5.4,11.1,6.8,12 c0.2,0.1,0.5,0.1,0.7,0c1.4-0.8,6.5-4.2,6.8-12C81.2,13.6,80.9,13.3,80.5,13.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M73.7,21.9c-0.4,0-0.8,0-1.2-0.1s-0.7-0.1-1-0.3v-0.7c0.7,0.3,1.4,0.4,2.2,0.4v-2.7c0,0,0,0-0.1,0 c-0.7-0.3-1.2-0.5-1.6-0.8c-0.3-0.3-0.5-0.7-0.5-1.2c0-0.5,0.2-0.9,0.6-1.2c0.4-0.3,0.9-0.5,1.5-0.5V14h0.7v0.9 c0.6,0,1.2,0.1,1.7,0.3v0.7c-0.6-0.2-1.1-0.3-1.7-0.3v2.6c0.5,0.2,0.9,0.3,1.1,0.5c0.3,0.2,0.5,0.3,0.6,0.6 c0.2,0.2,0.2,0.5,0.2,0.9c0,0.5-0.2,0.9-0.5,1.2c-0.3,0.3-0.8,0.5-1.5,0.6v0.9h-0.7V21.9z M73.7,15.5c-0.4,0.1-0.7,0.2-0.9,0.3 c-0.2,0.2-0.3,0.4-0.3,0.7c0,0.3,0.1,0.5,0.3,0.7c0.2,0.2,0.5,0.4,1,0.6V15.5z M75.6,20.1c0-0.3-0.1-0.5-0.3-0.7 c-0.2-0.2-0.5-0.3-0.9-0.5v2.3C75.2,21.1,75.6,20.7,75.6,20.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 64,
    y1: 7.9,
    x2: 66.2,
    y2: 10.1
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 82,
    y1: 25.9,
    x2: 84.2,
    y2: 28.1
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 84.2,
    y1: 7.9,
    x2: 82,
    y2: 10.1
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 66.2,
    y1: 25.9,
    x2: 64,
    y2: 28.1
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 61.4,
    y1: 18,
    x2: 62.9,
    y2: 18
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 85.3,
    y1: 18,
    x2: 86.8,
    y2: 18
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 74.1,
    y1: 5.3,
    x2: 74.1,
    y2: 6.8
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 74.1,
    y1: 29.2,
    x2: 74.1,
    y2: 30.7
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconM9);
export default __webpack_public_path__ + "static/media/icon-m-9.a5c0dc75cfbe35d392a5fa2ab511a4f1.svg";
export { ForwardRef as ReactComponent };